import React from 'react';

import LoadingIndicator from '@dashboard/components/loading/LoadingIndicator';
import ButtonLink from '@dashboard/components/mui-atoms/ButtonLink';
import BaseSettingCard from '@dashboard/components/platform-settings/BaseSettingCard';
import useCurrentWpPlatform from '@dashboard/hooks/useCurrentWpPlatform';
import { TipsAndUpdatesOutlined } from '@mui/icons-material';
import { Alert, Grid, Stack, Typography } from '@mui/material';

import AlertsCard from './AlertsCard';
import ApiKeysList from './ApiKeysList';
import ApprovedSendersList from './ApprovedSendersList';
import BillingConfigurationEdit from './BillingConfigurationEdit';
import EventsTrackingCard from './EventsTrackingCard';
import PlatformConfigurationEdit from './PlatformConfigurationEdit';
import TeamPage from './TeamPage';
import VerifiedDomainsList from './VerifiedDomainsList';
import WebhookDefinitionsList from './WebhookDefinitionsList';

export default function PlatformSettingsPage() {
  const { data } = useCurrentWpPlatform();

  const activeWaypointTier = data?.Platform.activeWaypointTier;

  const renderChildren = () => {
    if (activeWaypointTier === undefined) {
      return <LoadingIndicator />;
    }
    if (activeWaypointTier === 'SAMPLE') {
      return (
        <BaseSettingCard title="Settings">
          <Alert variant="outlined" severity="info" sx={{ py: 2 }} icon={<TipsAndUpdatesOutlined />}>
            <Typography paragraph>
              Settings are disabled on sample workspaces. When you create your own workspace, you'll be able to manage
              your domains, senders, billing, teammates, and API keys from your settings page.
            </Typography>
            <ButtonLink size="small" variant="outlined" href="/organizations/new">
              Create workspace
            </ButtonLink>
          </Alert>
        </BaseSettingCard>
      );
    }
    return (
      <>
        <PlatformConfigurationEdit />
        <VerifiedDomainsList />
        <ApprovedSendersList />
        <EventsTrackingCard />
        <BillingConfigurationEdit />
        <TeamPage />
        <ApiKeysList />
        <WebhookDefinitionsList />
        <AlertsCard />
      </>
    );
  };

  return (
    <Grid container justifyContent="center" sx={{ my: { xs: 1, md: 3 } }}>
      <Grid item xs={12} md={10} lg={8} xl={7}>
        <Stack spacing={3}>{renderChildren()}</Stack>
      </Grid>
    </Grid>
  );
}
